import { useCallback, useState } from 'react';

// status: 'idle' | 'sending' | 'success' | 'error'
export function useEmailJS() {
  const [status, setStatus]             = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const send = useCallback(async (templateParams) => {
    setStatus('sending');
    setErrorMessage('');

    try {
      const res = await fetch('/contact.php', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(templateParams),
      });

      const data = await res.json();

      if (data.success) {
        setStatus('success');
      } else {
        throw new Error(data.message || 'Failed to send message.');
      }
    } catch (err) {
      setErrorMessage(err.message || 'Failed to send message. Please try again.');
      setStatus('error');
    }
  }, []);

  const reset = useCallback(() => {
    setStatus('idle');
    setErrorMessage('');
  }, []);

  return { status, errorMessage, send, reset };
}
